import { Component, type ErrorInfo, type ReactNode } from 'react'

interface State { error: Error | null }

/**
 * A render error must never turn into a blank white screen on someone's phone —
 * show what broke and offer a way out.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[StaySuite] render error', error, info.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    return (
      <div className="min-h-full flex items-center justify-center p-6">
        <div className="max-w-lg w-full bg-surface border border-border rounded-2xl p-6">
          <h1 className="text-lg font-semibold mb-2">Da ist etwas schiefgegangen</h1>
          <p className="text-muted text-sm mb-4">
            Die Ansicht konnte nicht dargestellt werden. Die Daten sind nicht verloren.
          </p>
          <pre className="text-xs bg-surface-2 rounded-lg p-3 overflow-auto max-h-48 mb-4">
            {error.message}
          </pre>
          <button
            className="px-4 py-2 rounded-xl bg-accent text-accent-fg font-medium"
            onClick={() => window.location.reload()}
          >
            Neu laden
          </button>
        </div>
      </div>
    )
  }
}
